import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { confirm: String }

  delete(event) {
    event.preventDefault()
    const confirmed = confirm(this.confirmValue || "Are you sure?")
    if (!confirmed) return

    const url = event.target.getAttribute("href")
    this.deleteItem(url)
      .then(() => this.onTrackDestroySuccess(event))
      .catch(error => console.error("Delete failed:", error))
  }

  async deleteItem(href) {
    const response = await fetch(href, {
      method: 'DELETE',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      }
    })

    if (!response.ok) throw new Error(`HTTP error ${response.status}`)
    return response
  }

  onTrackDestroySuccess(event) {
    event.stopPropagation()
    let trackElement = event.target.closest(".group\\/track")
    
    if (!trackElement) {
      const trackId = event.target.getAttribute("data-track-id") || 
                    event.target.closest("[data-track-id]")?.getAttribute("data-track-id")
      
      if (trackId) {
        trackElement = document.querySelector(`[data-track-id="${trackId}"]`)
      }
    }
    
    if (trackElement) {
      trackElement.remove()
    } else {
      console.warn("Could not find track element to remove")
    }
  }
}
